import COS from '@tencent/new-cos-js-sdk-v5';
import { getImportCosConfig } from '../../../api';

let cosConfig: any | undefined = undefined;

const getCosConfig = async (gameId: string, envId: string, envGuid: string) => {
  if (!cosConfig) {
    cosConfig = await getImportCosConfig(gameId, envId, envGuid);
  }
  return cosConfig;
};

const getImportCosInstance = () => {
  return new COS({
    // 直接使用配置中的 credentials
    getAuthorization: (options, callback) => {
      // 同步返回预配置的 credentials
      callback({
        TmpSecretId: cosConfig?.result?.credentials?.tmpSecretId,
        TmpSecretKey: cosConfig?.result?.credentials?.tmpSecretKey,
        SecurityToken: cosConfig?.result?.credentials?.sessionToken || '',
        StartTime: cosConfig?.result?.startTime,
        ExpiredTime: cosConfig?.result?.expiredTime,
      });
    },
  });
};

export const putImportObject = async (
  fileName: string,
  file: File,
  gameId: string,
  envId: string,
  envGuid: string
) => {
  await getCosConfig(gameId, envId, envGuid);
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `/${gameId}/env_import/${fileName}`;

  const match = cosConfig.QCLOUD_COS_API_DOMAIN.match(
    /^(.+)\.cos-internal\.([^.]+)\.tencentcos\.cn$/
  );
  const [, bucket, region] = match;

  const importCOS = getImportCosInstance();

  await importCOS.putObject({
    Bucket: bucket,
    Region: region,
    Key: fileKey,
    Body: file,
  });
};

export const getImportFileUrl = async (
  gameId: string,
  envId: string,
  envGuid: string,
  fileName?: string
) => {
  await getCosConfig(gameId, envId, envGuid);
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `/${gameId}/env_import/${fileName}`;

  const match = cosConfig.QCLOUD_COS_API_DOMAIN.match(
    /^(.+)\.cos-internal\.([^.]+)\.tencentcos\.cn$/
  );
  const [, bucket, region] = match;

  const importCOS = getImportCosInstance();

  const uploadParams = {
    Bucket: bucket,
    Region: region,
    Key: fileKey,
  };
  const url = await new Promise<string>((resolve, reject) => {
    importCOS.getObjectUrl(uploadParams, (err, data) => {
      if (err) {
        reject(err);
      }
      resolve(data.Url);
    });
  });
  return url;
};
